import { ContextMenuItem } from '@seen/ui'
import { IconTrash } from '@tabler/icons-react'
import type { JSX } from 'react'
import {
  type DeleteConfirmationProps,
  useDeleteConfirmationStore,
} from '#src/hooks/useDeleteConfirmationStore.ts'

interface ContextMenuDeleteItemProps {
  deleteConfirmationProps: DeleteConfirmationProps
  disabled?: boolean
}

export function ContextMenuDeleteItem({
  deleteConfirmationProps,
  disabled,
}: ContextMenuDeleteItemProps): JSX.Element {
  const open = useDeleteConfirmationStore((state) => state.open)
  return (
    <ContextMenuItem
      className="gap-2"
      onSelect={() => {
        // We need to request an animation frame because the context menu sets pointer-events-none on the body. If we then immediately open the confirmation dialog, it will save that state and restore it after it's closed. So we wait a frame for the context menu to unset pointer-events-none.
        requestAnimationFrame(() => open(deleteConfirmationProps))
      }}
      disabled={disabled}
    >
      <IconTrash size={16} className="stroke-muted-foreground" />
      Delete…
    </ContextMenuItem>
  )
}
